import {mainQuery} from '@github-ui/react-core/future/main-query'
import {railsPartialQuery} from '@github-ui/react-core/future/rails-partial-query'

import {reactSandboxFutureAppBuilder} from '../config/app-builder'

type SandboxBlockingPayload = {
  someField: string
  serverTime: string
}

export const reactSandboxFutureRailsPartialsRoute = reactSandboxFutureAppBuilder.createQueryRouteConfig(
  'reactSandboxFutureRailsPartialsRoute',
  {
    path: '/_react_sandbox_future/rails_partials',
    queries: [
      mainQuery<SandboxBlockingPayload>(),
      railsPartialQuery({
        partialName: 'LeftContent',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/left_content`}
        },
      }),
      railsPartialQuery({
        partialName: 'RightContent',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/right_content`}
        },
      }),
      railsPartialQuery({
        partialName: 'HeadContent',
        queryDeps: ({pathname}) => {
          return {pathname: `${pathname}/head_content`}
        },
      }),
    ],
  },
)
